import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { BreadcrumbService } from 'src/app/_services/breadcrumb.service';
import { DeleteRecordService } from 'src/app/_services/delete-record.service';
import { TasksService } from 'src/app/_services/tasks.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';

// @angular/google-maps
import { GoogleMap} from '@angular/google-maps';

@Component({
    selector: 'app-view-journey',
    templateUrl: './view-journey.component.html',
    standalone: false
})
export class ViewJourneyComponent extends SubscriptionUtil implements OnInit, OnDestroy {

  @Input() data: any;
  @Input() journeyId: any;

  // ── Replaced: @ViewChild reference to GoogleMap for fitBounds / DirectionsRenderer ──
  @ViewChild('googleMap', { static: false }) googleMap!: GoogleMap;

  title: any;
  taskJourney: any;
  tripList: any[] = [];
  startLocation: any = {};
  endLocation: any = {};
  infoWindowOpened = null;
  dateTimeFormat: any;
  timezone: any;
  zoom: number = 10;

  // ── Replaced: options: any ───────────────────────────────────────────────────
  mapOptions: google.maps.MapOptions = { scrollwheel: true };
  mapCenter: google.maps.LatLngLiteral = { lat: 3.100176, lng: 101.591085 };
  mapZoom: number = 14;

  // ── Replaced: overlays: any[] (native google.maps.Marker array) ─────────────
  //    Markers are now data objects bound to <map-marker *ngFor>
  mapMarkers: { position: google.maps.LatLngLiteral; options: google.maps.MarkerOptions }[] = [];

  // ── Replaced: google.maps.Polyline set directly on map ──────────────────────
  //    Polyline path bound to <map-polyline [path]>
  polylinePath: google.maps.LatLngLiteral[] = [];
  polylineOptions: google.maps.PolylineOptions = {
    strokeOpacity: 0,
    strokeWeight: 2,
    strokeColor: '#6366F1',
    geodesic: true,
  };

  // DirectionsRenderer — still needs direct map access via GoogleMap.googleMap
  // ── Replaced: this.map (raw map ref from setGMap) → this.googleMap.googleMap ─
  private directionsRenderer: google.maps.DirectionsRenderer | null = null;

  showMap = false;

  public latitude: number = 3.100176;
  public longitude: number = 101.591085;

  private id: any;
  taskId: any;
  userId: any;
  refresher!: Subscription;
  translate: any;

  constructor(
    private taskService: TasksService,
    private auth: AuthenticationService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private deleteRecordService: DeleteRecordService,
    private breadcrumbService: BreadcrumbService,
    private languageTranslateService: LanguageTranslateService,
  ) {
    super();

    this.refresher = this.taskService.refreshList$.subscribe((item: any) => {
      console.log(item);
      if (item == 'Deleted Journey') {
        this.router.navigate(['/dashboard/tasks/journeys'], {
          queryParams: { taskId: this.taskId, userId: this.userId },
        });
      }
    });
  }

  ngOnInit() {
    this.spinner.show();
    this.taskId = this.data.id;
    this.userId = this.data.assignedTo.id;
    this.getLanguageData();

    // ── Removed: this.options = { center, zoom } ────────────────────────────────
    //    Now set as mapCenter / mapZoom properties above

    this.dateTimeFormat = `${localStorage.getItem('date_format')}`;
    this.timezone = this.auth.getUserTimezone();
  }

  /****************************************** Load BreadCrumb *****************************/
  loadBreadCrum() {
    this.breadcrumbService.setSetupItems([
      { label: this.translate?.task.label.plural, routerLink: ['/dashboard/tasks'], meta: { navigation: { root: true } } },
      {
        label: this.taskJourney.taskInfo.taskName,
        command: (e: any) => {
          this.router.navigate(['/dashboard/tasks/view'], { queryParams: { id: this.taskId } });
        },
      },
      {
        label: this.translate?.journey.label.plural,
        command: (e: any) => {
          this.router.navigate(['/dashboard/tasks/journeys'], { queryParams: { taskId: this.taskId, userId: this.userId } });
        },
      },
      { label: this.translate?.general.buttons.view + ' ' + this.translate?.journey.label.plural, meta: { navigation: { include: true } } },
    ]);
  }

  loadData() {
    this.taskService.getJourneyTripsById(this.journeyId).subscribe((res: any) => {
      this.spinner.hide();
      this.taskJourney = res.userLocationRouteTable;
      this.tripList = res.tripList;
      this.tripList.forEach((element: any) => {
        element.strokeColor = 'red';
      });

      this.startLocation = {
        lat: res.tripList[0].latitude,
        lng: res.tripList[0].longitude,
        markerUrl: '../../../../assets/images/mapIcons/current_location_marker.png',
        address: this.taskJourney.startLocationAddress,
      };
      this.endLocation = {
        lat: res.userLocationRouteTable.endLocationUserDetails.latitude,
        lng: res.userLocationRouteTable.endLocationUserDetails.longitude,
        markerUrl: '../../../../assets/images/map-icons/1.png',
        address: this.taskJourney.endLocationAddress,
      };

      const markers = [this.startLocation, this.endLocation];

      // Center map on start location
      this.mapCenter = { lat: this.startLocation.lat, lng: this.startLocation.lng };

      if (this.taskJourney.estimateDistance) {
        this.displayRoute(markers);
      } else {
        this.processMap(markers, this.tripList).then(() => {});
      }
    });
  }

  // ── Removed: setGMap($event) ─────────────────────────────────────────────────
  //    Was: this.map = $event.map  (from p-gmap's (onMapReady) event)
  //    Now: use this.googleMap.googleMap directly wherever raw map is needed

  /******************************************** Process Map ******************************************/
  private processMap(markers: any[], polyLines: any[]) {
    return new Promise<void>(async (resolve) => {
      // ── Replaced: processMarkers returning native google.maps.Marker[] ────────
      //    Now sets mapMarkers (data array) and returns LatLngLiteral[] for bounds
      const markerPositions = this.processMarkers(markers);
      this.processPolyline(polyLines);

      // ── Replaced: latlngBounds + gMarker.getPosition() ──────────────────────
      //    Use LatLngLiteral positions directly for fitBounds
      const bounds = new google.maps.LatLngBounds();
      markerPositions.forEach((pos) => bounds.extend(pos));

      // ── Replaced: this.map.fitBounds → this.googleMap.googleMap?.fitBounds ───
      setTimeout(() => {
        this.googleMap?.googleMap?.fitBounds(bounds);
      }, 500);

      resolve();
    });
  }

  /******************************************** Process Markers ******************************************/
  // ── Replaced: returns native google.maps.Marker[] ───────────────────────────
  //    Now populates mapMarkers data array, returns LatLngLiteral[] for bounds
  private processMarkers(markers: any[]): google.maps.LatLngLiteral[] {
    this.mapMarkers = markers.map((marker: any) => ({
      position: { lat: marker.lat, lng: marker.lng },
      options: {
        title: marker.address,
        icon: marker.markerUrl ?? marker.icon,
      },
    }));

    return this.mapMarkers.map((m) => m.position);
  }

  /******************************************** Process Polyline ******************************************/
  // ── Replaced: new google.maps.Polyline + poly.setMap(this.map) ──────────────
  //    Now sets polylinePath bound to <map-polyline [path]>
  private processPolyline(polyLines: any[]) {
    this.polylinePath = polyLines.map((pl: any) => ({ lat: pl.lat, lng: pl.lon }));
  }

  /******************************************** Display Route via DirectionsService ******************************************/
  // ── DirectionsRenderer still needs the raw map object ───────────────────────
  //    Replaced: directionsDisplay.setMap(this.map) → setMap(this.googleMap.googleMap)
  displayRoute(markers: any[]) {
    const start = new google.maps.LatLng(
      this.taskJourney.startLocationUserDetails.latitude,
      this.taskJourney.startLocationUserDetails.longitude
    );
    const end = new google.maps.LatLng(
      this.taskJourney.endLocationUserDetails.latitude,
      this.taskJourney.endLocationUserDetails.longitude
    );

    // ── Replaced: directionsDisplay.setMap(this.map) ────────────────────────
    //    Wait for GoogleMap to be ready, then set map on renderer
    if (this.directionsRenderer) {
      this.directionsRenderer.setMap(null);
    }
    this.directionsRenderer = new google.maps.DirectionsRenderer();

    const attachRenderer = () => {
      if (this.googleMap?.googleMap) {
        this.directionsRenderer!.setMap(this.googleMap.googleMap);
      } else {
        setTimeout(attachRenderer, 200);
      }
    };
    attachRenderer();

    const request: any = {
      origin: start,
      destination: end,
      travelMode: google.maps.TravelMode.DRIVING,
    };

    const directionsService = new google.maps.DirectionsService();
    directionsService.route(request, (response: any, status: any) => {
      if (status == google.maps.DirectionsStatus.OK) {
        this.directionsRenderer!.setDirections(response);

        // ── Replaced: new google.maps.Polyline + poly.setMap(this.map) ────────
        //    Build polylinePath from overview_path for <map-polyline>
        this.polylinePath = response.routes[0].overview_path.map((pl: any) => ({
          lat: pl.lat(),
          lng: pl.lng(),
        }));

        // ── Replaced: new google.maps.Marker array + latlngBounds ─────────────
        //    Process markers as data objects; fitBounds via googleMap reference
        const markerPositions = this.processMarkers(markers);

        const bounds = new google.maps.LatLngBounds();
        markerPositions.forEach((pos) => bounds.extend(pos));

        setTimeout(() => {
          this.googleMap?.googleMap?.fitBounds(bounds);
        }, 1000);
      }
    });
  }

  edit(e: any) {
    if (e === 'edit') {
      this.router.navigate(['dashboard/tasks/journeys/update'], {
        queryParams: {
          taskId: this.taskId,
          userId: this.userId,
          id: this.taskJourney.id,
          name: this.taskJourney.taskInfo.taskName,
        },
      });
    } else if (e === 'delete') {
      this.taskJourney.deleteHeader = this.translate.task.label.singular + ' ' + this.translate.journey.label.singular;
      this.taskJourney.deleteType = 'Task Journey';
      this.taskJourney.message = this.translate?.general.messages.confirmDelete;
      this.deleteRecordService.getItems(this.taskJourney);
    }
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.loadData();
        }
      })
    );
    console.log('translate', this.translate);
  }

  push(obs: any) {
    super.push(obs);
  }

  ngOnDestroy(): void {
    if (this.directionsRenderer) {
      this.directionsRenderer.setMap(null);
    }
    super.ngOnDestroy();
  }
}